import { render, staticRenderFns } from "./MallAdUploadCsv.vue?vue&type=template&id=0f809bbf&scoped=true&"
import script from "./MallAdUploadCsv.vue?vue&type=script&lang=js&"
export * from "./MallAdUploadCsv.vue?vue&type=script&lang=js&"
import style0 from "./MallAdUploadCsv.vue?vue&type=style&index=0&id=0f809bbf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f809bbf",
  null
  
)

export default component.exports